import ErrorRequestFailed from './ErrorRequestFailed.js'

class ErrorRequestFailedLocally extends ErrorRequestFailed {
  constructor (message, ...args) {
    let now = new Date()
    super([
      {
        'name': 'ErrorLocal',
        'message': 'Something went wrong! Please refresh the page.',
        'time_thrown': now.toISOString(),
        'data': {}
      }
    ], message, ...args)
  }
}

export default ErrorRequestFailedLocally



// WEBPACK FOOTER //
// ./src/models/ErrorRequestFailedLocally.js